<template>
    <footer class="bg-white">
      <div class="mx-auto max-w-screen-xl px-4 py-8 sm:px-6 lg:px-8">
        <div class="sm:flex sm:items-center sm:justify-between">
          <div class="flex justify-center text-teal-600 sm:justify-start">
            <div class="flex flex-col">
        <h1 class="text-black">Portfolio Emma Nabyt</h1>
        <hr class="border-cv border-2 rounded-full">
      </div>
          </div>
    
          <p class="mt-4 text-center text-sm text-gray-500 lg:mt-0 lg:text-right">
            Copyright &copy; 2025. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  </template>